// active initiative
const state = {
  Phase: '' // Mobilise, Assess, Design, Implement, Sustain
}

const mutations = {
  setPhase (state, val) {
    state.Phase = val
  },
  setSuccessProfileRisks (state, val) {
    state.successProfileRisk[val.index] = val.risk
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/initiative/index.js